module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-minus-37216c22.svg";